import { render } from "./BasicLabel.vue?vue&type=template&id=1c0af5a2&scoped=true"
import script from "./BasicLabel.vue?vue&type=script&lang=js"
export * from "./BasicLabel.vue?vue&type=script&lang=js"

import "./BasicLabel.vue?vue&type=style&index=0&id=1c0af5a2&scoped=scoped&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c0af5a2"]])

export default __exports__